import { Injectable } from '@angular/core';
import {Form, PaymentState} from "../interfaces/form-model";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PaymentStateService {

  paymentState$: BehaviorSubject<PaymentState>;

  constructor() {
    this.paymentState$ = new BehaviorSubject<PaymentState>(this.getInitialPaymentState());
  }

  getPaymentState$(): Observable<PaymentState> {
    return this.paymentState$.asObservable();
  }

  getPaymentState(): PaymentState {
    return this.paymentState$.getValue();
  }

  initializePaymentState(formData: Form): void {
    let state = this.getInitialPaymentState();

    const paymentSection = formData.sections.find(section => 6 === section.type);
    if(paymentSection) {
      const invoice = paymentSection.elements.find(element => 363 === element.type);
      state.hasInvoicing  = !!(invoice && invoice.templateOptions.display);

      const creditCard = paymentSection.elements.find(element => 361 === element.type);
      state.hasCC = !!(creditCard && creditCard.templateOptions.display);

      const eft = paymentSection.elements.find(element => 362 === element.type);
      state.hasEFT = !!(eft && eft.templateOptions.display);

      const offlinePayment = paymentSection.elements.find(element => 364 === element.type);
      state.hasOfflinePayment = !!(offlinePayment && offlinePayment.templateOptions.display);

      if(state.hasInvoicing && (state.hasCC || state.hasEFT)) {
        state.hidePaymentBtns = true;
        state.hideInvoiceBtn = true;
      }

      if(!state.hasInvoicing && (state.hasCC || state.hasEFT)) {
        state.hideInvoiceBtn = true;
      }

      if(!state.hasInvoicing && !state.hasCC && !state.hasEFT) {
        state.paymentPage = false;
        state.hideSubmit = true;
      }

      if(state.hasInvoicing && (!state.hasCC || !state.hasEFT)) {
        state.hidePaymentBtns = true;
      }

      if(state.hasInvoicing && (state.hasCC || state.hasEFT) || state.hasOfflinePayment) {
        state.hasMultiplePayments = true;
      }

    } else {
      state.paymentPage = false;
      state.paymentType = "";
    }

    this.paymentState$.next(state);
  }

  setPaymentType(value: string): void {
    const state = this.paymentState$.getValue();
    const newState = { ...state, paymentType: value };
    this.paymentState$.next(newState);
  }

  private getInitialPaymentState(): PaymentState {
    return {
      hidePaymentBtns: false,
      hideSubmit: false,
      hideInvoiceBtn: false,
      hasOfflinePayment: false,
      hasEFT: false,
      hasCC: false,
      hasInvoicing: false,
      paymentPage: true,
      hasMultiplePayments: false,
      paymentType: ""
    }
  }
}
